// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Scrollbar } from 'smooth-scrollbar-react';
import axios from 'axios';
import _ from 'lodash';

// Interne Module
import { convertPrice } from '@/_helper/mapper';
import tracking from '@/_helper/tracking';
import * as storage from '@/_helper/storage';
import { buildPostRequest } from '@/_helper/apiHelper';
import { seating_arrangements } from '../extra-services/seat-reservation/_config';
import { isInternalIp, setRealBooking } from '@/_helper/dynamicTestBooking';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import ProgressBar from '@/comp/loadingOffersBar/ProgressBar';
import PhoneInput from '@/comp/form/phoneInput/PhoneInput';
import Button from '@/comp/button/button.tsx';
import ServiceToBeBooked from './serviceToBeBooked/ServiceToBeBooked';
import MailForBookingConfirmation from './mailForBookingConfirmation/MailForBookingConfirmation';
import Participants from './participants/Participants';
import TravelFactsBooking from './travelFactsBooking/TravelFactsBooking';

// Assets
import ssl from '@/assets/img/ssl-small.png';

// Styles
import './booking.scss';
import { Icon } from '@/comp/icon/icon.tsx';
import { Tooltip } from '@/comp/toolTip/tooltip.tsx';

const params = {
    errorWording: {
        acceptAGB: 'Bitte bestätigen Sie, dass Sie die AGB gelesen und zur Kenntnis genommen haben!',
        acceptSurcharge: 'Bitte bestätigen Sie, dass Sie mit dem Aufpreis einverstanden sind!',
        acceptPhoneNumber: [
            'Festnetznummern sind zur Anmeldung nicht möglich, bitte geben Sie eine valide Mobilnummer ein.',
            'Bitte geben Sie eine Telefonnummer an, die mindestens 10 Ziffern lang ist!',
            'Bitte bestätigen Sie, dass Sie über die angegebene Telefonnummer kontaktiert werden können!',
        ],
    },
};

const isInternal = isInternalIp();

class Booking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bookingData: storage.get('bookingData'),
            bookStates: JSON.parse(sessionStorage.getItem('bookStates')),
            bookingNumber: storage.get('bookingNumber'),
            bookingParams: {},
            loading: true,
            hasError: false,
            error: null,
            layers: {
                infoLayer: {
                    show: false,
                },
            },
            acceptAGB: false,
            acceptAGBValid: false,
            acceptSurcharge: false,
            acceptSurchargeValid: false,
            acceptPhoneNumberValid: false,
            alreadyTested: false,
            formErrors: {
                acceptAGB: '',
                acceptSurcharge: '',
                acceptPhoneNumber: '',
            },
            formValid: false,
            formVacancy: false,
            getCheckedPersons: '',
            getOtherPayment: null,
            mailForBookingConfirmation: {
                value: '',
                error: false,
            },
            emergencyPhoneNumber: undefined,
        };

        this.mailForBookingConfirmationChange = this.mailForBookingConfirmationChange.bind(this);
        this.getBookingParams = this.getBookingParams.bind(this);
        this.getCheckedPersonsChange = this.getCheckedPersonsChange.bind(this);
        this.getOtherPaymentChange = this.getOtherPaymentChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.Modal = this.Modal.bind(this);
        this.setMobileNumber = this.setMobileNumber.bind(this);
    }

    componentDidMount() {
        document.title = 'Buchung ' + window.$documentTitle;

        if (this.state.bookStates === null) {
            window.location.href = '#/';
            return false;
        }

        if (this.state.bookStates.status === 'success') {
            window.location.href = '#/uebersicht';
        }

        if (storage.get('bookingData') !== null && storage.get('bookingData').bookingParams !== undefined) {
            this.setState({
                bookingParams: storage.get('bookingData').bookingParams,
                loading: false,
            });
        } else {
            this.getBookingParams();
        }

        if (this.state.bookingData !== undefined && this.state.bookStates.travelType !== null) {
            if (this.state.bookStates.travelType === 'seatReservation') {
                // seatReservation : browser back no vacancyToken
                if (this.state.bookStates.vacancyToken === undefined) {
                    window.location.href = '#/sitzplatzreservierung';
                }

                if (sessionStorage.getItem('tabsync')) {
                    sessionStorage.removeItem('tabsync');
                    this.setState({
                        tabsync: true,
                    });
                }

                // check storage : change
                window.addEventListener('storage', (event) => {
                    let newValue = JSON.parse(event.newValue);
                    let oldValue = JSON.parse(event.oldValue);

                    if (newValue?.vacancyToken === undefined) {
                        return false;
                    }

                    if (
                        (newValue.vacancyToken !== undefined && oldValue.vacancyToken !== undefined) ||
                        oldValue.vacancyToken === undefined
                    ) {
                        if (newValue.vacancyToken !== oldValue.vacancyToken) {
                            sessionStorage.setItem('tabsync', true);
                            window.location.reload();
                        }
                    }

                    if (this.state.bookStates.vacancyToken === undefined) {
                        window.location.href = '#/sitzplatzreservierung';
                    }
                });
            }
        }
    }

    getBookingParams() {
        if (storage.get('access_token') !== null) {
            const loginData = {
                requestType: 'bookingData',
                bookingId: storage.get('bookingNumber'),
                action: 'getBookingParams',
                clientId: 'customerarea',
                requestSource: 'AurumTours-Customerarea',
                hash: storage.get('access_token'),
            };

            axios(buildPostRequest(window.$serviceUrl, '/bookingData', loginData))
                .then((response) => response)
                .then((data) => {
                    let response = data.data.data.data;

                    if (response !== null) {
                        this.setState({
                            bookingParams: response,
                            loading: false,
                        });

                        let bookingData = _.assign(storage.get('bookingData'), {
                            bookingParams: response,
                        });

                        storage.set('bookingData', bookingData);
                    } else {
                        this.setState({
                            loading: false,
                            hasError: true,
                        });
                    }
                })
                .catch((error) => this.setState({ error }));
        }
    }

    mailForBookingConfirmationChange(m, error) {
        this.setState({
            mailForBookingConfirmation: {
                value: m,
                error: error,
            },
        });

        if (m.length === 0) {
            this.setState({
                formValid: false,
            });
        } else {
            this.setState({
                formValid: true,
            });
        }
    }

    getCheckedPersonsChange(c) {
        this.setState({
            getCheckedPersons: c,
        });
    }

    getOtherPaymentChange(c) {
        this.setState({
            getOtherPayment: c,
        });
    }

    totalPrice() {
        if (
            this.state.bookStates !== null &&
            this.state.bookStates.vacancyData !== null &&
            this.state.bookStates.vacancyData !== undefined
        ) {
            let totalPrice = this.state.bookStates.vacancyData.price.packagePrice;
            return parseFloat(totalPrice);
        }
    }

    setMobileNumber(numberParts) {
        let emergencyPhoneNumber = undefined;

        if (numberParts !== undefined) {
            emergencyPhoneNumber = {
                phoneCountry: numberParts.phoneCountryPrefix ?? '',
                phoneAreaCode: numberParts.phoneAreaCode ?? '',
                phoneNumber: numberParts.phoneNumber ?? '',
                lengthValid: numberParts.lengthValid ?? false,
                isLandline: numberParts.isLandline ?? false,
            };
        }

        this.setState({ emergencyPhoneNumber: emergencyPhoneNumber }, () => {
            this.validateForm();
        });
    }

    handleUserInput(event) {
        const target = event.target;
        const name = target.name;

        this.setState({ [name]: target.value }, () => {
            this.validateField(name, target.checked);
        });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let acceptAGBValid = this.state.acceptAGBValid;
        let acceptSurchargeValid = this.state.acceptSurchargeValid;
        let acceptPhoneNumberValid = this.state.acceptPhoneNumberValid;
        let realBooking = this.state.realBooking || false;

        switch (fieldName) {
            case 'acceptAGB':
                acceptAGBValid = value;
                fieldValidationErrors.acceptAGB = acceptAGBValid ? '' : params.errorWording.acceptAGB;
                break;
            case 'acceptSurcharge':
                acceptSurchargeValid = value;
                fieldValidationErrors.acceptSurcharge = acceptSurchargeValid ? '' : params.errorWording.acceptSurcharge;
                break;
            case 'acceptPhoneNumber':
                acceptPhoneNumberValid = value;
                break;
            case 'realBooking':
                realBooking = value;
                break;
            default:
                break;
        }
        this.setState(
            {
                formErrors: fieldValidationErrors,
                acceptAGBValid: acceptAGBValid,
                acceptSurchargeValid: acceptSurchargeValid,
                acceptPhoneNumberValid: acceptPhoneNumberValid,
                realBooking: realBooking,
            },
            this.validateForm
        );
    }

    validatePhoneNumberForm() {
        // phone number validation only in excursion booking
        if (this.state.bookStates.travelType !== 'excursion') {
            return true;
        }

        const emergencyPhoneNumber = this.state.emergencyPhoneNumber;
        const checkboxValid = this.state.acceptPhoneNumberValid;
        const formErrors = this.state.formErrors;

        // error if phone number is not mobile number
        if (emergencyPhoneNumber?.isLandline) {
            formErrors.acceptPhoneNumber = params.errorWording.acceptPhoneNumber[0];
        }
        // error if checkbox is checked but phone number is empty
        else if (checkboxValid && (emergencyPhoneNumber?.lengthValid === false || emergencyPhoneNumber === undefined)) {
            formErrors.acceptPhoneNumber = params.errorWording.acceptPhoneNumber[1];
        }
        // error if phone number isn't empty but checkbox isn't checked
        else if (!checkboxValid && emergencyPhoneNumber !== undefined) {
            formErrors.acceptPhoneNumber = params.errorWording.acceptPhoneNumber[2];
        } else {
            formErrors.acceptPhoneNumber = '';
        }

        this.setState({ formErrors: formErrors });

        const phoneNumberValid =
            (!this.state.acceptPhoneNumberValid && emergencyPhoneNumber === undefined) ||
            (this.state.acceptPhoneNumberValid &&
                emergencyPhoneNumber !== undefined &&
                emergencyPhoneNumber.lengthValid &&
                !emergencyPhoneNumber.isLandline);

        return phoneNumberValid;
    }

    validateForm() {
        this.setState({
            formValid: this.validatePhoneNumberForm() && this.state.acceptAGBValid && this.state.acceptSurchargeValid,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({ alreadyTested: true });

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs

            let fieldValidationErrors = this.state.formErrors;
            fieldValidationErrors.acceptAGB = params.errorWording.acceptAGB;
            fieldValidationErrors.acceptSurcharge = params.errorWording.acceptSurcharge;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }

        // form is valid!
        this.setState({
            error: false,
        });

        if (this?.state?.bookStates?.ibeInstance === 'ibe_3') {
            this.submitBookingIBE_3();
        } else {
            this.submitBookingIBE_2();
        }
    }

    submitBookingIBE_2() {
        let $this = this,
            $travelType = this.state.bookStates.travelType,
            $vacancyData = this.state.bookStates.vacancyData;

        // error : mailForBookingConfirmation
        if (this.state.mailForBookingConfirmation.value.length === 0) {
            this.mailForBookingConfirmationChange(this.state.mailForBookingConfirmation.value, true);
        }

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            return;
        }

        // form is valid!
        // book
        let bookingData = storage.get('bookingData').bookingParams;
        let serviceInformation = storage.get('bookingData').data.serviceInformation;

        //  participants
        let getParticipants = [];
        if (this.state.getCheckedPersons !== undefined) {
            _.forEach(this.state.getCheckedPersons, function (v) {
                getParticipants.push(_.omit(v, ['checked']));
            });
        } else {
            this.setState({
                error: true,
            });
            return false;
        }

        //  customer
        let getCustomer = {};
        if (bookingData.customer !== undefined) {
            getCustomer = {
                bookingId: null,
                customerType: 'individual',
                salutation: bookingData.customer.salutation,
                foreName: bookingData.customer.foreName,
                surName: bookingData.customer.surName,
                dateOfBirth: bookingData.customer.dateOfBirth,
                companyName: '',
                salesTaxId: '',
                street: bookingData.customer.street,
                streetNumber: bookingData.customer.streetNumber,
                postalCode: bookingData.customer.postalCode,
                city: bookingData.customer.city,
                countryCode: bookingData.customer.countryCode,
                countryName: '',
                eMailAddress: bookingData.customer.eMailAddress,

                phoneCountry: bookingData.customer.phoneCountry,
                phoneAreaCode: bookingData.customer.phoneAreaCode,
                phoneNumber: bookingData.customer.phoneNumber,

                ssoId: 0,
                ssoType: 'existing',
                ssoPointAmount: 0,
                ssoPointPlanId: 0,
                updatedAddress: false,
                scoreValue: null,
                badPastScore: false,
            };

            if ($travelType === 'excursion' && this.state.emergencyPhoneNumber) {
                const emergencyPhoneNumber = this.state.emergencyPhoneNumber;

                getCustomer.customerType = 'emergency';
                getCustomer.phoneCountry = emergencyPhoneNumber.phoneCountry;
                getCustomer.phoneAreaCode = emergencyPhoneNumber.phoneAreaCode;
                getCustomer.phoneNumber = emergencyPhoneNumber.phoneNumber;
            }

            if (this.state.mailForBookingConfirmation.value !== null) {
                getCustomer['additionalEMailAddress'] = this.state.mailForBookingConfirmation.value;
            }
        } else {
            this.setState({
                error: true,
            });
            return false;
        }

        let paymentData = null;

        if (this.state.bookingParams.currentPaymentData.type === 'bankTransfer') {
            paymentData = {
                paymentDataType: 'bankTransfer',
            };
        }

        let sendBookParams = {
            vacancyToken: this.state.bookStates.vacancyToken,
            mainBookingId: storage.get('bookingNumber'),
            customer: getCustomer,
            participants: getParticipants,
            paymentData: paymentData,
            payments: [
                {
                    bookingId: null,
                    bookingPaymentStateId: null,
                    paymentType: 'earlierBooking',
                    currency: 'EUR',
                    amount: 0,
                    state: 'open',
                },
            ],
            deviceType: 'desktop',
            requestType: 'book',
            clientId: 'customerarea',
            processToken: this.state.bookStates.processToken,
            travelType: this.state.bookStates.travelType,
        };

        if ($travelType === 'transfer') {
            let hotelSupplier = '';
            let hotelSupplierBookingId = '';

            if (
                serviceInformation !== undefined ||
                serviceInformation.hotel !== undefined ||
                serviceInformation.hotel.supplier === undefined
            ) {
                this.setState({
                    error: true,
                    formValid: true,
                });
            }

            if (serviceInformation.hotel.supplier !== undefined) {
                hotelSupplier = serviceInformation.hotel.supplier;
            }

            if (serviceInformation.hotel.bookingId !== undefined) {
                hotelSupplierBookingId = serviceInformation.hotel.bookingId;
            }

            // add : transferOfferId
            _.assign(sendBookParams, {
                transferFlightParameters: storage.get('bookingData').data.flightDetailParams,
                hotelSupplier: hotelSupplier,
                hotelSupplierBookingId: hotelSupplierBookingId,
            });
        }

        if ($travelType === 'excursion') {
            let hotelSupplier = '';
            let hotelSupplierBookingId = '';

            if (
                serviceInformation !== undefined ||
                serviceInformation.hotel !== undefined ||
                serviceInformation.hotel.supplier === undefined
            ) {
                this.setState({
                    error: true,
                    formValid: true,
                });
            }

            if (serviceInformation.hotel !== undefined && serviceInformation.hotel.supplier !== undefined) {
                hotelSupplier = serviceInformation.hotel.supplier;
            }

            if (serviceInformation.hotel !== undefined && serviceInformation.hotel.bookingId !== undefined) {
                hotelSupplierBookingId = serviceInformation.hotel.bookingId;
            }

            _.assign(sendBookParams, {
                hotelSupplier: hotelSupplier,
                hotelSupplierBookingId: hotelSupplierBookingId,
            });
        }

        if ($travelType === 'seatReservation') {
            let { participantsData, legData } = this.state.bookStates;

            // set offerKeyParticipantMap
            let transportAncillaryOfferKeys = {};

            if (participantsData !== undefined && legData !== undefined) {
                Object.keys(legData).forEach((lKey) => {
                    if (legData[lKey].allParticipantsBooked !== true) {
                        Object.keys(participantsData).forEach((key) => {
                            Object.keys(participantsData[key].seat).forEach(() => {
                                if (
                                    participantsData[key].seat[lKey]?.offerKey !== undefined &&
                                    participantsData[key].seat[lKey]?.booked !== true
                                ) {
                                    transportAncillaryOfferKeys[participantsData[key].seat[lKey].offerKey] = key;
                                }
                            });
                        });
                    }
                });
            }

            _.assign(sendBookParams, {
                offerKeyParticipantMap: transportAncillaryOfferKeys,
            });

            // set participants
            sendBookParams.participants = this.state.bookingParams.travellers;
        }

        if (isInternal && this.state.bookStates?.travelType) {
            const realBooking = setRealBooking(this.state.bookStates.travelType, this.state.realBooking);
            sendBookParams = {
                ...sendBookParams,
                testCases: realBooking,
            };
        }

        this.setState({
            formVacancy: true,
            error: false,
        });

        axios(buildPostRequest(window.$requestUrl, '/book', JSON.stringify(sendBookParams)))
            .then((response) => response)
            .then(function (response) {
                // notBooked : notTriedToBook : partlyBooked -> nicht erneut buchbar
                if (
                    response.data.data.bookingState === 'notBooked' ||
                    response.data.data.bookingState === 'partlyBooked' ||
                    response.data.data.bookingState === 'notTriedToBook'
                ) {
                    // Weiterleitung status seite
                    window.location.href = '#/buchung-fehlgeschlagen?page=' + $travelType;
                    return false;
                }

                // rejected -> erneut buchbar
                if (response.data.data.bookingState === 'rejected') {
                    if ($travelType === 'seatReservation') {
                        /*
                         * the vacancy request
                         * transportAncillaryOfferKeys enthält eine Liste an OfferKeys aus der SearchResponse die ausgewählt wurden.
                         */
                        function request(sendData) {
                            axios(buildPostRequest(window.$requestUrl, '/vacancy', JSON.stringify(sendData)))
                                .then((response) => response)
                                .then((data) => {
                                    // Der requestToken identifiziert die Vakanz eindeutig.
                                    // Anschließende book-Requests müssen immer einen Vakanz requestToken referenzieren.
                                    switch (data.data.data?.overallPackageVacancyResult) {
                                        case 'ok':
                                            break;
                                        case 'failed':
                                            // error : seat
                                            let failedOfferKeys = [];
                                            let seatReservationOffers = data.data.data.seatReservationOffers;
                                            if (seatReservationOffers.length > 0) {
                                                Object.keys(seatReservationOffers).forEach((key) => {
                                                    if (seatReservationOffers[key].occupation !== 'available') {
                                                        failedOfferKeys.push(seatReservationOffers[key].offerKey);
                                                    }
                                                });
                                            }

                                            let bookStates = $this.state.bookStates;
                                            bookStates['error'] = {
                                                state: true,
                                                offerKeys: failedOfferKeys,
                                            };
                                            $this.setState({
                                                bookStates: bookStates,
                                            });
                                            break;
                                        default:
                                            break;
                                    }
                                });
                        }

                        let transportAncillaryOfferKeys = [];
                        Object.keys(sendBookParams.offerKeyParticipantMap).forEach((key) => {
                            if (key !== undefined) {
                                transportAncillaryOfferKeys.push(key);
                            }
                        });

                        const sendData = {
                            clientId: 'customerarea',
                            processToken: sendBookParams.processToken,
                            travelType: 'seatReservation',
                            requestType: 'vacancy',
                            vacancyType: 'complete',
                            ignoreCache: true,
                            transportAncillaryOfferKeys: transportAncillaryOfferKeys,
                        };
                        request(sendData);

                        let formErrors = $this.state.formErrors;
                        formErrors.seatReservation = true;
                        $this.setState({
                            formErrors: formErrors,
                        });
                    } else {
                        this.setState({
                            error: true,
                        });

                        let $this = this;
                        setTimeout(function () {
                            $this.setState({
                                error: false,
                            });
                        }, 5000);
                    }

                    $this.setState({
                        formVacancy: false,
                    });
                }

                // success
                if (response.data.data.bookingState === 'booked' || response.data.data.bookingState === 'mocked') {
                    let bookStates = {
                        bookingId: response.data.data.mainBookingId,
                        status: response.data.data.bookingResult,
                        travelType: $travelType,
                    };
                    sessionStorage.setItem('bookStates', JSON.stringify(bookStates));

                    // add booked service
                    let bookedService;
                    if (storage.get('bookingData').bookedService === undefined) {
                        bookedService = { bookedService: {} };
                    } else {
                        bookedService = storage.get('bookingData');
                    }

                    if (bookedService.bookedService[$travelType] === undefined) {
                        bookedService.bookedService[$travelType] = [];
                    }

                    switch ($travelType) {
                        case 'seatReservation':
                            tracking('success', 'seatReservation');
                            if (!window.$affiliate) {
                                window.$gtmTracking.gtag('event', 'page_success', { page: 'seatReservation' });
                            }

                            let bookingStats = $this.state.bookStates;

                            // clean up data
                            delete bookingStats.processToken;
                            delete bookingStats.vacancyToken;
                            delete bookingStats.vacancyData;
                            delete bookingStats.travelType;

                            bookedService.bookedService[$travelType] = {
                                bookingStats: bookingStats,
                            };

                            break;
                        case 'excursion':
                            tracking('success', 'excursion');
                            if (!window.$affiliate) {
                                window.$gtmTracking.gtag('event', 'page_success', { page: 'excursion' });
                            }
                            bookedService.bookedService[$travelType] = _.concat(
                                bookedService.bookedService[$travelType],
                                {
                                    title: $vacancyData.title,
                                    category: $vacancyData.category,
                                    travellers: getParticipants,
                                }
                            );
                            break;
                        case 'transfer':
                            tracking('success', 'transfer');
                            if (!window.$affiliate) {
                                window.$gtmTracking.gtag('event', 'page_success', { page: 'transfer' });
                            }
                            bookedService.bookedService[$travelType] = {
                                data: {
                                    serviceDescription: $vacancyData.description,
                                    tariffCode: $vacancyData.tariffCode,
                                    price: $vacancyData.price.overallGrossPrice,
                                },
                            };
                            break;
                        case 'insurance':
                            bookedService.bookedService[$travelType] = {
                                data: {
                                    serviceDescription: $vacancyData.serviceDescription,
                                    price: $vacancyData.price.overallGrossPrice,
                                },
                            };

                            break;
                        case 'railAndFly':
                            tracking('success', 'railAndFly');
                            if (!window.$affiliate) {
                                window.$gtmTracking.gtag('event', 'page_success', { page: 'railAndFly' });
                            }
                            bookedService.bookedService[$travelType] = _.concat(
                                bookedService.bookedService[$travelType],
                                {
                                    data: {
                                        serviceDescription: $vacancyData.description,
                                        remarks: $vacancyData.remarks,
                                        price: $vacancyData.price.overallGrossPrice,
                                        direction: $vacancyData.direction,
                                    },
                                }
                            );

                            break;
                        default:
                            break;
                    }

                    // clear tab storage : reload other open tabs
                    if (localStorage?.tabs) {
                        let storageHelper = JSON.parse(localStorage.tabs);
                        delete storageHelper[sessionStorage.tabID];
                        localStorage.tabs = JSON.stringify(storageHelper);
                        localStorage.tabRefresh = Date.now();
                    }

                    storage.set(
                        'bookingData',
                        _.assign(storage.get('bookingData'), bookedService, {
                            additionalEMailAddress: getCustomer['additionalEMailAddress'],
                        })
                    );

                    window.location.href = '#/uebersicht';
                }
            })
            .catch((error) => this.setState({ error, formVacancy: false }));
    }

    submitBookingIBE_3() {
        const { travelType, vacancyToken, processToken, vacancyData } = this.state.bookStates;

        // Map submit action to action
        const mapSubmitAction = {
            transferCruise: 'bookTransfer',
        };

        // Build submit booking data
        let sendSubmitBookingData = {
            action: mapSubmitAction[travelType],
            requestType: 'bookingData',
            bookingId: storage.get('bookingNumber') || '',
            firstPaxName: storage.get('firstPaxName') || '',
            travelStart: storage.get('travelStart') || '',
            processToken,
            vacancyToken,
            requestSource: 'AurumTours-Customerarea',
        };

        // Add real booking data if internal booking
        if (isInternal && travelType) {
            const realBooking = setRealBooking(travelType, this.state.realBooking);
            sendSubmitBookingData = {
                ...sendSubmitBookingData,
                testCases: realBooking,
            };
        }

        // Set form vacancy
        this.setState({
            formVacancy: true,
            error: false,
        });

        // Submit Booking API Call
        axios(buildPostRequest(window.$serviceUrl, '/bookingData', JSON.stringify(sendSubmitBookingData)))
            .then((response) => response)
            .then((response) => {
                const { ibeResponse } = response.data.data.data;
                const { bookingState, mainBookingId, bookingResult } = ibeResponse;

                // notBooked : notTriedToBook : partlyBooked -> nicht erneut buchbar
                if (
                    bookingState === 'notBooked' ||
                    bookingState === 'partlyBooked' ||
                    bookingState === 'notTriedToBook'
                ) {
                    // Weiterleitung status seite
                    window.location.href = '#/buchung-fehlgeschlagen?page=' + travelType;
                    return false;
                }

                // success
                if (bookingState === 'booked' || bookingState === 'mocked') {
                    let bookStates = {
                        bookingId: mainBookingId,
                        status: bookingResult,
                        travelType,
                    };
                    sessionStorage.setItem('bookStates', JSON.stringify(bookStates));

                    // add booked service
                    let bookedService;
                    if (storage.get('bookingData').bookedService === undefined) {
                        bookedService = { bookedService: {} };
                    } else {
                        bookedService = storage.get('bookingData');
                    }

                    if (bookedService.bookedService[travelType] === undefined) {
                        bookedService.bookedService[travelType] = [];
                    }

                    switch (travelType) {
                        case 'transferCruise':
                            tracking('success', 'transferCruise');
                            if (!window.$affiliate) {
                                window.$gtmTracking.gtag('event', 'page_success', { page: 'transferCruise' });
                            }
                            bookedService.bookedService[travelType] = {
                                data: {
                                    serviceDescription: vacancyData?.description,
                                    tariffCode: vacancyData?.tariffCode,
                                    price: vacancyData?.price?.overallGrossPrice,
                                },
                            };
                            break;
                        default:
                            break;
                    }

                    // clear tab storage : reload other open tabs
                    if (localStorage?.tabs) {
                        let storageHelper = JSON.parse(localStorage.tabs);
                        delete storageHelper[sessionStorage.tabID];
                        localStorage.tabs = JSON.stringify(storageHelper);
                        localStorage.tabRefresh = Date.now();
                    }

                    window.location.href = '#/uebersicht';
                }
            })
            .catch((error) => this.setState({ error, formVacancy: false }));
    }

    extraFullTitle(travelType) {
        let { vacancyData } = this.state.bookStates;
        let extraFullTitle = '';

        let titleMapper = {
            railAndFly: {
                both: 'Roundtrip',
                inbound: 'einfache Rückfahrt',
                outbound: 'einfache Hinfahrt',
            },
        };

        switch (travelType) {
            case 'transfer':
                if (window.$content?.extras[travelType].title !== undefined) {
                    extraFullTitle = window.$content.extras[travelType].title;
                }

                let subtitle =
                    window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()] !== undefined &&
                    window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()].heading !== undefined
                        ? window.$content.mappingTransfer[vacancyData.tariffCode.toLowerCase()].heading
                        : vacancyData.tariffCode.charAt(0).toUpperCase() +
                          vacancyData.tariffCode.toLowerCase().slice(1).replace('_', '-');

                extraFullTitle += ' - ' + subtitle;

                break;
            case 'railAndFly':
                if (window.$content?.extras[travelType].title !== undefined) {
                    extraFullTitle = window.$content.extras[travelType].title;
                }

                if (titleMapper[travelType] !== undefined && vacancyData.direction !== undefined) {
                    extraFullTitle += ' - ' + titleMapper[travelType][vacancyData.direction];
                }
                break;
            case 'excursion':
                extraFullTitle = 'Ausflug';

                break;
            case 'seatReservation':
                extraFullTitle = 'Sitzplatzreservierungen';

                break;
            default:
        }

        return extraFullTitle;
    }

    Modal() {
        return (
            <div className="modal-background-overlay">
                <div className="modal-container">
                    <div className="modal-header">
                        <div className="aurum-logo"></div>
                        <span role="button" aria-label="schließen" className="modal-close" onClick={this.closeModal}>
                            <Icon name="close" size={30} ariaHidden />
                        </span>
                    </div>
                    <div className="modal-content">
                        <h2>Zahlungs- und Stornierungsbedingungen für Ausflüge</h2>
                        <p className="modal-text">
                            Für Ihre Ausflugsbuchung gilt die Anzahlungskategorie{' '}
                            {this.state.bookStates.depositCategory} und die Stornierungskategorie{' '}
                            {this.state.bookStates.cancellationCategory} ({this.state.bookStates.bookingCategory}).
                        </p>
                        <h3>Zahlung</h3>
                        <p className="modal-text">
                            Die Zahlung des Ausflugs ist bis 30 Tage vor Abreise in voller Höhe zu begleichen. Sollte
                            die Abreise in weniger als 30 Tagen sein, ist die Zahlung des Ausflugs im Anschluss an die
                            Buchung in voller Höhe zu begleichen.
                        </p>
                        <h3>Stornierung</h3>
                        <p className="modal-text">
                            Der gebuchte Ausflug ist bis 24 Stunden vor Anreise kostenlos stornierbar.
                            <br />
                            Danach fallen Stornierungskosten in Höhe von 100% an.
                        </p>

                        <div className="modal-button-container">
                            <Button handleClick={this.closeModal} label="Ja, ich habe die Bestimmungen verstanden" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    closeModal = () => {
        this.setState((state) => {
            state.modal = false;
            return state;
        });
    };

    acceptAGBText(travelType) {
        let acceptAGBText = [];
        switch (travelType) {
            case 'excursion':
                acceptAGBText.push(
                    <p key={travelType}>
                        Mit dem Vorgang "jetzt zahlungspflichtig buchen" bestätige ich, dass ich alle oben stehenden
                        Daten und Eingaben überprüft habe und die Richtigkeit meiner Angaben vorliegt.
                        <br />
                        <br />
                        Ich akzeptiere die{' '}
                        <a rel="noopener noreferrer" href={`${window.$website}/unternehmen/agb`} target="_blank">
                            Allgemeinen Geschäftsbedingungen
                        </a>{' '}
                        der Kategorie {this.state.bookStates.bookingCategory} sowie die
                        <button
                            className="button-back"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({ modal: true });
                            }}>
                            Zahlungs- und Stornierungsbedingungen
                        </button>{' '}
                        der AurumTours GmbH im Bezug auf den von mir gewählten Ausflug.
                    </p>
                );
                break;
            case 'seatReservation':
                acceptAGBText.push(
                    <p key={travelType}>
                        Mit Klick auf "Jetzt zahlungspflichtig buchen" bestätige ich, dass ich alle oben stehenden Daten
                        und Eingaben überprüft habe und die Richtigkeit meiner Angaben vorliegt.
                        <br />
                        Ich akzeptiere die{' '}
                        <a rel="noopener noreferrer" href={`${window.$website}/unternehmen/agb`} target="_blank">
                            Allgemeinen Geschäftsbedingungen
                        </a>{' '}
                        der AurumTours GmbH sowie die{' '}
                        <span className="color-primary" onClick={(e) => this.handleLayerClick(e)}>
                            Sitzplatzregelungen
                        </span>{' '}
                        der Fluggesellschaft SunExpress.
                    </p>
                );
                break;
            default:
                acceptAGBText.push(
                    <p key={travelType}>
                        Mit Klick auf "Jetzt zahlungspflichtig buchen" bestätige ich, dass ich alle oben stehenden Daten
                        und Eingaben überprüft habe und die Richtigkeit meiner Angaben vorliegt.
                        <br />
                        Ich akzeptiere die{' '}
                        <a rel="noopener noreferrer" href={`${window.$website}/unternehmen/agb`} target="_blank">
                            Allgemeinen Geschäftsbedingungen
                        </a>{' '}
                        der AurumTours GmbH im Bezug auf die gewählte Zusatzleistung{' '}
                        {window.$content.extras[this.state.bookStates.travelType].title}{' '}
                        {travelType === 'transferCruise' && (
                            <>
                                sowie die{' '}
                                <Link to="/datenschutz" target="_blank">
                                    Datenschutzbestimmungen
                                </Link>{' '}
                                der AurumTours GmbH
                            </>
                        )}
                        .
                    </p>
                );
        }

        return acceptAGBText;
    }

    acceptSurchargeText(travelType) {
        let acceptSurchargeText = [];
        switch (travelType) {
            case 'excursion':
                acceptSurchargeText.push(
                    <p key={travelType}>
                        Ja, ich willige ein, dass der Aufpreis für den Ausflug mit der ursprünglich bei Buchung
                        angegebenen Zahlungsmethode zu begleichen ist bzw. von AurumTours abgebucht wird.
                    </p>
                );
                break;
            case 'seatReservation':
                acceptSurchargeText.push(
                    <p key={travelType}>
                        Ja, ich willige ein, dass der Aufpreis für die Sitzplatzreservierungen mit der ursprünglich bei
                        Buchung angegebenen Zahlungsmethode zu begleichen ist bzw. von AurumTours abgebucht wird.
                        Sitzplatzreservierungen sind nicht kostenfrei stornierbar.
                    </p>
                );
                break;
            default:
                acceptSurchargeText.push(
                    <p key={travelType}>
                        Ja, ich willige ein, dass der Aufpreis für die Zusatzleistung{' '}
                        {window.$content.extras[this.state.bookStates.travelType].title} mit der ursprünglich bei
                        Buchung angegebenen Zahlungsmethode zu begleichen ist bzw. von AurumTours abgebucht wird.
                    </p>
                );
        }

        return acceptSurchargeText;
    }

    handleLayerClick(e) {
        e.preventDefault();

        let layers = { ...this.state.layers };
        layers.infoLayer.show = true;
        this.setState({
            layers: layers,
        });
    }

    seatingArrangementsLayer() {
        if (!this.state.layers.infoLayer.show) {
            return false;
        }

        let layers = { ...this.state.layers };

        const close = () => {
            layers.infoLayer.show = false;
            this.setState({
                layers: layers,
            });
        };

        return (
            <div className="info-layer">
                <div className="inline">
                    <div className="head">
                        <div className="aurum-logo"></div>

                        <div
                            className="close"
                            aria-label="schließen"
                            onClick={() => {
                                close();
                            }}>
                            <Icon name="close" ariaHidden />
                        </div>
                    </div>
                    <Scrollbar>
                        <div className="content">{seating_arrangements()}</div>
                    </Scrollbar>
                    <div className="footer">
                        <Button
                            handleClick={() => {
                                close();
                            }}
                            label="Ja, ich habe die Bestimmungen verstanden"
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { bookingParams, bookingData, loading } = this.state;

        let newTotalPrice = this.totalPrice();

        if (!bookingData) {
            return false;
        }
        const isMediatedCruise = bookingData.data?.frontendParams?.mediatedServices.cruise;

        if (
            bookingData.data?.frontendParams !== undefined &&
            bookingData.data.frontendParams?.price.total !== undefined
        ) {
            newTotalPrice += bookingData.data.frontendParams?.price.total;
        }

        return (
            <div className="page-booking">
                <Header />

                {this.seatingArrangementsLayer()}

                {this.state.bookStates && this.state.bookStates.vacancyData === null && (
                    <div className="content-wrapper">
                        <div className="error">{window.$content.errorText}</div>
                    </div>
                )}

                {this.state.bookStates && this.state.bookStates.vacancyData && (
                    <div className="content-wrapper">
                        <div className="page-content">
                            <h2 className="main heading">
                                Jetzt Daten prüfen und{' '}
                                {this.state.bookStates.travelType === 'seatReservation'
                                    ? window.$content.extras[this.state.bookStates.travelType].title
                                    : 'buchen'}{' '}
                            </h2>

                            {this.state.tabsync && (
                                <div className="main error-line seat-reservation">
                                    <Icon name="report" ariaHidden />
                                    <div className="text">
                                        Ihre ausgewählten Sitzplätze wurden technisch aktualisiert. Bitte prüfen Sie
                                        Ihre Auswahl.
                                    </div>
                                </div>
                            )}

                            {/* service-to-be-booked */}
                            <ServiceToBeBooked
                                travelType={this.state.bookStates.travelType}
                                bookStates={this.state.bookStates}
                            />

                            {/* Travel Facts Booking : Hotel Cruise Flight Transfer  */}
                            <TravelFactsBooking />

                            {loading && <ProgressBar finishText="Buchung wird geladen..." />}

                            {this.state.hasError && (
                                <div className="error fail-booking-params">
                                    <p>{window.$content.errorText}</p>

                                    <Link to={'/' + this.state.bookStates.travelType} className="back-link">
                                        zurück
                                    </Link>
                                </div>
                            )}

                            {/*participants*/}
                            {this.state.bookStates.travelType !== 'seatReservation' && bookingParams.travellers && (
                                <Participants
                                    travellers={
                                        this.state.bookStates.travellers
                                            ? this.state.bookStates.travellers
                                            : bookingParams.travellers
                                    }
                                    travelType={this.state.bookStates.travelType}
                                    getCheckedPersonsChange={this.getCheckedPersonsChange}
                                />
                            )}

                            {/* TODO: kann das gelöscht werden? */}
                            {false && ( // REDP-19411 deactivate feature
                                <MailForBookingConfirmation
                                    mailForBookingConfirmation={this.state.mailForBookingConfirmation}
                                    mailForBookingConfirmationChange={this.mailForBookingConfirmationChange}
                                />
                            )}

                            <div>
                                {/*price overview */}
                                <div
                                    className={`sec price-overview active ${this.state.formVacancy ? 'validate' : ''}`}>
                                    <div className="intro-line">
                                        <div className="summary-headline">
                                            Ihre Reise mit{' '}
                                            {this.state.bookStates.travelType !== 'seatReservation'
                                                ? 'Zusatzleistung - '
                                                : ' '}
                                            {window.$content.extras[this.state.bookStates.travelType].title}
                                        </div>
                                    </div>
                                    <div className="content">
                                        <div className="price-summary">
                                            {bookingData.data?.frontendParams.price.total !== undefined && (
                                                <div className="line">
                                                    <div className="price-small-print">
                                                        {isMediatedCruise ? (
                                                            <>
                                                                (Gesamtpreis für alle Reisenden exklusive des
                                                                Kreuzfahrtpreises)
                                                                <Tooltip
                                                                    placement={
                                                                        window.$browserInfo.device === 'mobile'
                                                                            ? 'top'
                                                                            : 'right'
                                                                    }>
                                                                    Der Kreuzfahrtpreis wird Ihnen von der vermittelten
                                                                    Reederei separat mitgeteilt
                                                                </Tooltip>
                                                            </>
                                                        ) : (
                                                            <>(Gesamtpreis für alle Reisenden)</>
                                                        )}
                                                    </div>
                                                    <div className="price">
                                                        {' '}
                                                        {convertPrice(bookingData.data.frontendParams.price.total)}
                                                    </div>
                                                </div>
                                            )}

                                            <div className="line">
                                                <div className="price-small-print">
                                                    {this.extraFullTitle(this.state.bookStates.travelType)}
                                                </div>
                                                <div className="price">
                                                    {this.totalPrice() >= 0 ? '+' : '-'}{' '}
                                                    {convertPrice(this.totalPrice())}
                                                </div>
                                            </div>

                                            {newTotalPrice !== null && (
                                                <div className="line total-price">
                                                    <div className="text-bold">Neuer Gesamtpreis</div>
                                                    <div className="price">{convertPrice(newTotalPrice)}</div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="small-print-section">
                                            <div className="small-print">
                                                <div className="cnt">
                                                    <input
                                                        id="acceptAGB"
                                                        name="acceptAGB"
                                                        type="checkbox"
                                                        onChange={(event) => this.handleUserInput(event)}
                                                    />
                                                    <label htmlFor="acceptAGB">
                                                        {this.acceptAGBText(this.state.bookStates.travelType)}
                                                    </label>

                                                    {this.state.alreadyTested &&
                                                        this.state.acceptAGBValid === false &&
                                                        this.state.formErrors.acceptAGB.length > 0 && (
                                                            <div className="error">
                                                                {this.state.formErrors.acceptAGB}
                                                            </div>
                                                        )}
                                                </div>

                                                <div className="cnt">
                                                    <input
                                                        id="acceptSurcharge"
                                                        name="acceptSurcharge"
                                                        type="checkbox"
                                                        onChange={(event) => this.handleUserInput(event)}
                                                    />
                                                    <label htmlFor="acceptSurcharge">
                                                        {this.acceptSurchargeText(this.state.bookStates.travelType)}
                                                    </label>

                                                    {this.state.alreadyTested &&
                                                        this.state.acceptSurchargeValid === false &&
                                                        this.state.formErrors.acceptSurcharge.length > 0 && (
                                                            <div className="error">
                                                                {this.state.formErrors.acceptSurcharge}
                                                            </div>
                                                        )}
                                                </div>

                                                {this.state.bookStates.travelType === 'excursion' && (
                                                    <>
                                                        <div className="cnt">
                                                            <input
                                                                id="acceptPhoneNumber"
                                                                name="acceptPhoneNumber"
                                                                type="checkbox"
                                                                onChange={(event) => this.handleUserInput(event)}
                                                            />
                                                            <label htmlFor="acceptPhoneNumber">
                                                                Freiwillige Angabe Ihrer Telefonnummer: Ja, ich bin
                                                                damit einverstanden, dass ich am Urlaubsort über diese
                                                                mobile Telefonnummer kontaktiert werde, falls es
                                                                kurzfristige Änderungsinformationen zum gebuchten
                                                                Ausflug gibt.
                                                            </label>
                                                        </div>
                                                        <PhoneInput
                                                            label={'Telefonnummer (zum Beispiel +49 176 112233344)'}
                                                            setMobileNumber={this.setMobileNumber}
                                                        />
                                                        {this.state.alreadyTested &&
                                                            this.state.formErrors.acceptPhoneNumber?.length > 0 && (
                                                                <div className="error">
                                                                    {this.state.formErrors.acceptPhoneNumber}
                                                                </div>
                                                            )}
                                                    </>
                                                )}

                                                {isInternal && (
                                                    <div className="cnt">
                                                        <input
                                                            id="realBooking"
                                                            type="checkbox"
                                                            name="realBooking"
                                                            onChange={(event) => this.handleUserInput(event)}
                                                        />
                                                        <label htmlFor="realBooking" className="real-booking">
                                                            Ja, ich möchte scharf durchbuchen (Nur für interne IPs
                                                            sichtbar).
                                                        </label>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="pricing">
                                                <div className="price-cnt">
                                                    <div className="line">
                                                        <div className="title">Aufpreis</div>
                                                        <div className="price txtR">
                                                            {this.totalPrice() >= 0 ? '+' : '-'}{' '}
                                                            {convertPrice(this.totalPrice())}
                                                        </div>
                                                    </div>
                                                    {this.state.bookStates.travelType === 'excursion' ? (
                                                        <div className="price-small-print">
                                                            (für alle Teilnehmenden)
                                                        </div>
                                                    ) : (
                                                        <div className="price-small-print">(für alle Reisenden)</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <form
                                    className={this.state.formVacancy ? 'validate' : ''}
                                    autoComplete="off"
                                    onSubmit={this.handleSubmit}
                                    method="post"
                                    noValidate="">
                                    <div>
                                        {!loading && (
                                            <div
                                                className={`user-action ${
                                                    this.state.formErrors?.seatReservation || this.state.tabsync
                                                        ? 'has-error'
                                                        : ''
                                                }`}>
                                                <div className="trust">
                                                    <div className="col">
                                                        <ul>
                                                            <li>Sichere Datenübertragung</li>
                                                            <li>Ausgezeichneter Service</li>
                                                            <li>Volle Preistransparenz</li>
                                                        </ul>
                                                    </div>

                                                    <div className="col seals">
                                                        <img src={ssl} alt="SSL" />
                                                    </div>
                                                </div>

                                                <div className="submit-sec">
                                                    {this.state.formErrors?.seatReservation && (
                                                        <div className="error-line seat-reservation">
                                                            <Icon name="report" ariaHidden />
                                                            <div className="text">
                                                                Die gewählten Sitze stehen leider nicht mehr zur
                                                                Verfügung. Bitte treffen Sie eine neue Auswahl.
                                                            </div>
                                                        </div>
                                                    )}

                                                    {this.state.tabsync && (
                                                        <div className="error-line seat-reservation">
                                                            <Icon name="report" ariaHidden />
                                                            <div className="text">
                                                                Ihre ausgewählten Sitzplätze wurden technisch
                                                                aktualisiert. Bitte prüfen Sie Ihre Auswahl.
                                                            </div>
                                                        </div>
                                                    )}

                                                    <Button
                                                        valid={this.state.formValid}
                                                        validated={this.state.formVacancy}
                                                        type="submit"
                                                        label={
                                                            this.state.formVacancy
                                                                ? 'Buchung wird durchgeführt ...'
                                                                : `Jetzt für ${convertPrice(this.totalPrice())} buchen`
                                                        }
                                                        icon="arrowForward"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {this.state.error && <div className={'error'}>{window.$content.errorText}</div>}
                                </form>
                            </div>
                        </div>
                        {this.state.modal && <this.Modal />}
                    </div>
                )}
                <Footer />
            </div>
        );
    }
}

export default Booking;
